var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjectSelectorBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8.33325C11.3807 8.33325 12.5 7.21396 12.5 5.83325C12.5 4.45254 11.3807 3.33325 10 3.33325C8.61929 3.33325 7.5 4.45254 7.5 5.83325C7.5 7.21396 8.61929 8.33325 10 8.33325Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 15.8333C15.5475 15.8333 16.6667 14.714 16.6667 13.3333C16.6667 11.9525 15.5475 10.8333 14.1667 10.8333C12.786 10.8333 11.6667 11.9525 11.6667 13.3333C11.6667 14.714 12.786 15.8333 14.1667 15.8333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 15.8333C7.21396 15.8333 8.33325 14.714 8.33325 13.3333C8.33325 11.9525 7.21396 10.8333 5.83325 10.8333C4.45254 10.8333 3.33325 11.9525 3.33325 13.3333C3.33325 14.714 4.45254 15.8333 5.83325 15.8333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectSelectorBlack);
export default __webpack_public_path__ + "static/media/Icon_ProjectSelector_Black.9224f5d20a6755d601da932440fdac4e.svg";
export { ForwardRef as ReactComponent };